// src/services/api.js
import axios from "axios";

const api = axios.create({
    // baseURL: "https://vetficacao.nutrire.ind.br/api",
  baseURL: "https://api.partner.nutrire.ind.br/api",
});

// Interceptor para adicionar cabeçalhos padrão (Authorization e Language)
api.interceptors.request.use(
  (config) => {
    // Obter o token do localStorage
    const token = localStorage.getItem("token");

    // Obter o idioma do localStorage
    const language = localStorage.getItem("language");

    // Adicionar o token ao cabeçalho Authorization, se disponível
    if (token) {
      config.headers.Authorization = token; // Token já deve incluir o tipo (e.g., "Bearer")
    }

    // Adicionar o idioma ao cabeçalho Language, se disponível
    if (language) {
      config.headers.Language = language;
    }

    return config;
  },
  (error) => {
    // Tratar erro na configuração da requisição
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas de erro
api.interceptors.response.use(
  (response) => response, // Retornar a resposta normalmente se não houver erro
  (error) => {
    // Verificar se é um erro de autenticação (401 ou 403)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Verificar se a requisição não é para a rota de login
      if (!error.config || !error.config.url.includes("/login")) {
        console.error("Token inválido ou expirado. Redirecionando para o login...");
        localStorage.removeItem("token"); // Remover o token inválido
        window.location.href = "/"; // Redirecionar para a página de login
      }
      // Se for para a rota de login, não redirecionar automaticamente
      // Permitir que o componente trate o erro
    }

    // Retornar a Promise com erro para permitir tratamento adicional
    return Promise.reject(error);
  }
);

export default api;
